@if (reportID && legacyReportID) {
    <div class="version-switch">
        <span>{{
            "dashboard-rmc.dashboard-reports.version-switch.old.label"
                | translate
        }}</span>
        <cap-input-switch
            [ariaLabel]="
                'dashboard-rmc.dashboard-reports.version-switch.new.label'
                    | translate
            "
            [ngModel]="!showLegacy"
            (ngModelChange)="toggleLegacy(!$event)"
        ></cap-input-switch>
        <span>{{
            "dashboard-rmc.dashboard-reports.version-switch.new.label"
                | translate
        }}</span>
    </div>
}

@if (reportID && stopLoading) {
    @if (showLegacy) {
        <cap-power-bi-report
            [reportId]="legacyReportID"
            [reportPage]="reportPageName"
            tokenEndpoint="/dashboard-rmc/report"
        >
        </cap-power-bi-report>
    } @else {
        <cap-power-bi-report
            [reportId]="reportID"
            [reportPage]="reportPageName"
            tokenEndpoint="/dashboard-rmc/report"
        >
        </cap-power-bi-report>
    }
}

@if (!reportID && stopLoading) {
    <div>
        {{
            "dashboard-rmc.dashboard-reports.report-not-found.label" | translate
        }}
    </div>
}

@if (!stopLoading) {
    <app-loader></app-loader>
}
